import type { SearchState } from '../types/SearchState';
import { getSpecificDirection } from '../getSpecificDirection';
import type { QueryParams } from './QueryParams';
import { formatAmount } from './amountUtils';
import { sanitizeBillId } from './sanitizeBillId';

export function transformSearchStateToQueryParams(
    state: SearchState = {
        amount: {},
        dates: {},
        billIdRange: {},
    },
): QueryParams {
    const {
        type,
        direction,
        keyword: q,
        dates: { startDate: from, endDate: to },
        amount: { minAmount, maxAmount },
        replaceBulkTransactions,
        includeFavourites,
        supplementaryCardIds,
        maskedCardNumber,
        cardIds,
        continuousCardIds,
        accounts,
        useFHSettings,
        tag,
        billIdRange: { billIdFrom, billIdTo },
        variableSymbol,
        transactionId,
    } = state;

    const specificDirection = getSpecificDirection(direction);

    return {
        ...(specificDirection && { direction: specificDirection }),
        ...(includeFavourites && { marked: String(includeFavourites) }),
        ...(supplementaryCardIds?.length && { maskedCardNumber: supplementaryCardIds }),
        ...(maskedCardNumber?.length && { maskedCardNumber }),
        ...(cardIds?.length && { cardId: cardIds }),
        ...(continuousCardIds?.length && { continuousCardId: continuousCardIds }),
        q,
        from,
        to,
        type,
        billIdFrom: sanitizeBillId(billIdFrom),
        billIdTo: sanitizeBillId(billIdTo),
        amountFrom: formatAmount(minAmount),
        amountTo: formatAmount(maxAmount),
        ...(accounts?.length && { id: accounts }),
        ...(useFHSettings && { useFHSettings: String(useFHSettings) }),
        tag,
        variableSymbol,
        ...(transactionId && { transactionId }),
        replaceBulkTransactions,
    };
}
